module.exports = __webpack_public_path__ + "img/index-img-05-01.cb0519a2.png";